import OrderReviewTop from "./order-review-top";
import OrderReviewDeliveryDetails from "./order-review-delivery-details";
import OrderReviewItems from "./order-review-items";
import OrderReviewTotal from "./order-review-total";
import { useReactToPrint } from "react-to-print";
import { useEffect, useRef } from "react";
import InvoiceDetails from "../invoice/invoice-details";

const OrderReview = (props: any) => {
  
  const componentRef = useRef(null);
  
  useEffect(() => {
    if(props.PrintEnabled)
    {
      handleOrderPrint();
    }      
  }, [props.PrintEnabled]);

  const handleOrderPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'Order Detail',
    onAfterPrint: () => props.TriggerPrint(false)
  });
  
  return (
    <>
      <div ref={componentRef} className="flex flex-column border-1 surface-border box-shadow-none m-0">
          <OrderReviewTop orderData={props.OrderData} />
          <OrderReviewDeliveryDetails deliveryDetails={props.OrderData} />
          <OrderReviewItems orderedItems={props.OrderData} />
          <OrderReviewTotal orderedItems={props.OrderData} /> 
          <InvoiceDetails orderInvoice={props.OrderData.orderInvoice} orderData={props.OrderData} />
      </div>
    </>
  );
};

export default OrderReview;
